import { FC } from 'react';
import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import SecondTypeButton from '../../button/SecondTypeButton';

interface IProps {
  handleClose: () => void;
  handleSubmit: () => void;
  type: string;
  action: string;
  disable?: boolean;
}

const ModalAction: FC<IProps> = ({ handleClose, handleSubmit, type, action, disable }) => {
  const setAction = (action: string) => {
    const last = action[action.length - 1];
    if (last === 'e') return action.slice(0, -1) + 'ing';
    else return `${action}ing`;
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleFullSumbit = () => {
    handleSubmit();
    enqueueSnackbar(`${setAction(action)} ${type}...`);
    handleClose();
  };

  return (
    <div className='col-2 modal__buttons'>
      <SecondTypeButton children='Cancel' onClick={() => handleClose()} />
      <Button
        variant='contained'
        onClick={handleFullSumbit}
        children={`${action} ${type}`}
        disabled={disable}
      />
    </div>
  );
};
export default ModalAction;
